import { render, staticRenderFns } from "./Ausstellung.vue?vue&type=template&id=21afea38&"
import script from "./Ausstellung.vue?vue&type=script&lang=js&"
export * from "./Ausstellung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports